<template>
  <sdCards :title="$t('pages.apps.modules.widget.edit-title')">
    <a-form layout="vertical" :model="formData" @submit="update">
      <a-form-item :label="$t('pages.apps.modules.widget.size') + ':'">
        <a-select default-value="1x1" v-model:value="formData.size">
          <a-select-option value="1x1"> 1x1 </a-select-option>
          <a-select-option value="1x2"> 1x2 </a-select-option>
          <a-select-option value="2x1"> 2x1 </a-select-option>
          <a-select-option value="2x2"> 2x2 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="URL:">
        <a-input placeholder="URL" :auto-size="{ minRows: 5, maxRows: 10 }" v-model:value="formData.url" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </sdCards>
</template>

<script>
export default {
  name: 'BlankPage',
  data() {
    return {
      app_id: this.$route.params.id,
      type: 'widget',
      iconLoading: true,
      formData: {
        size: '1x1',
        url: null,
        module_id: this.$route.params.widget_id,
      },
    };
  },
  methods: {
    update() {
      this.iconLoading = true;
      this.$appAxios
        .post(this.$endpoints.app_module_update, { id: this.app_id, formData: this.formData, type: this.type })
        .then((resp) => {
          if (resp.data.status) {
            this.$message.success(this.$t('common.success-message'));
            this.$store.dispatch('application/get', this.app_id);
          } else {
            this.$message.error(resp.data.message);
          }
          this.iconLoading = false;
        });
    },
    getDetail() {
      var _this = this;
      this.$appAxios
        .post(this.$endpoints.app_module_get, {
          id: this.app_id,
          type: this.type,
          formData: { module_id: this.formData.module_id },
        })
        .then((resp) => {
          if (resp.data.status) {
            _this.formData.size = resp.data.data.size;
            _this.formData.url = resp.data.data.url;
            _this.iconLoading = false;
          } else {
            this.$message.error(resp.data.message);
          }
        });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>